/**
 * This is really annoying hack that I will go back and fix.
 *
 * Our App was in an infinite loop on IE because the Auth0 SDK was expecting the es7 `finally`
 * method to be included on our promise. It isn't, and so it was just failing when that code tried
 * to run (ironically, after it successfully exchanged tokens)
 *
 * The exported method is to make Typescript / Eslint happy
 */
export const polyfillFinally = () => {
  if (!Promise.prototype.finally) {
    // eslint-disable-next-line no-extend-native, func-names
    Promise.prototype.finally = function (f: any) {
      return this.then(
        (value) => Promise.resolve(f()).then(() => value),
        (err) =>
          Promise.resolve(f()).then(() => {
            throw err;
          }),
      );
    };
  }
};
